/**
 * 店铺设置
 */
import { SHOPSETTING } from '../types';

export default {
    name: `${SHOPSETTING}`,
    path: '/shopSetting',
    component: () => import(/* webpackChunkName: 'shopSetting' */ '@/views/shopSetting/'),
    redirect: { name: `${SHOPSETTING}Index` },
    meta: {
        title: '店铺设置',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${SHOPSETTING}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'shopSetting' */ '@/views/shopSetting/home/Home.vue'),
        },
    ],
};
